import { FormControl, FormControlLabel, FormHelperText, Switch, Typography } from "@mui/material";
import { Controller } from "react-hook-form";
import RightToLeftLayout from "../RightToLeft";

const SwitchField = ({
  name,
  control,
  label,
  required = false,
  fullWidth = true,
  errorObject,
  className = "",
  disabled = false,
  size = "medium",
  ...rest
}) => {
  return (
    <RightToLeftLayout>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormControl
            fullWidth={fullWidth}
            required={required}
            error={!!error}
            className={className}
            component="fieldset"
          >
            <FormControlLabel
              control={
                <Switch
                  {...field}
                  checked={!!field.value}
                  onChange={(e) => field.onChange(e.target.checked)}
                  size={size}
                  disabled={disabled}
                  {...rest}
                />
              }
              label={
                <Typography sx={{ ml: 1, mr: 1, userSelect: "none", fontSize: "14px" }}>
                  {label}
                </Typography>
              }
              labelPlacement="start"
              sx={{ justifyContent: "space-between", margin: 0 }}
            />
            {(error?.message || errorObject?.message) && (
              <FormHelperText>{error?.message || errorObject?.message}</FormHelperText>
            )}
          </FormControl>
        )}
      />
    </RightToLeftLayout>
  );
};

export default SwitchField;
